import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { DesigningComponent } from './designing.component';
import { DesigningTutorialComponent } from './tutorial/tutorial.component';
import { DesigningEditingFunEasyComponent } from './editingFunEasy/editingFunEasy.component';
import { DesigningSmartThemeChangerComponent } from './smartThemeChanger/smartThemeChanger.component';
import { DesigningSmartLayoutOptionsComponent } from './smartLayoutOptions/smartLayoutOptions.component';
import { DesigningSmartPageEditsComponent } from './smartPageEdits/smartPageEdits.component';
import { DesigningProgressComponent } from './progress/progress.component';
import { DesigningDotsComponent } from './dots/dots.component';

@NgModule({
  declarations: [
    DesigningComponent,
    DesigningTutorialComponent,
    DesigningEditingFunEasyComponent,
    DesigningSmartThemeChangerComponent,
    DesigningSmartLayoutOptionsComponent,
    DesigningSmartPageEditsComponent,
    DesigningProgressComponent,
    DesigningDotsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
  ],
})
export class DesigningModule {}
